import ConsoleUtil from "../utils/ConsoleUtil";

class CommandManager {
    static  commandsSet: Map<string , (...args: any[]) => void>;

    constructor() {
        CommandManager.commandsSet = new Map<string , (...args: any[]) => void>();
    }

    public has(commandName: string): boolean {
        return CommandManager.commandsSet.has(commandName);
    }

    public setCommand(commandName: string, command: (...args: any[]) => void) {
        CommandManager.commandsSet.set(commandName, command);
    }

    public execute( commandName: string, args?: any) {
        if (CommandManager.commandsSet.has(commandName)) {
            CommandManager.commandsSet.get(commandName)(args);
        } else {
            ConsoleUtil.red("Command " + commandName + " not found!");
        }
    }

}

export default new CommandManager();
